module.exports = __webpack_public_path__ + "img/personalinfo.fb7d3bfc.svg";